"use strict";

exports.__esModule = true;
exports.defaultQueries = void 0;
const defaultQueries = exports.defaultQueries = {
  xs: '(max-width: 320px)',
  sm: '(max-width: 720px)',
  md: '(max-width: 1024px)',
  l: '(max-width: 1536px)'
};